<template>
	<div>
		<!-- <div class="header"></div> -->
		<div>
			<loading v-if="String(name).length == 0" />
			<div class="box" v-if="String(name).length > 0">
				<img src="@/assets/img/ats.png" style="width:100%;margin: 10px 0">
				<div>
					<p class="title text-center">AIR & TECH SHOW E-Ticket</p>
				</div>
				<div class="location" style="cursor: pointer;" @click="goMap()">
					<i class="material-icons" style="color: rgb(56,129,185)">place</i>
					<span>Pochentong Air Base, Phnom Penh</span>
				</div>

				<div class="top">
					<table>
						<tr>
							<td class="table-title table-left">Date</td>
							<td class="table-title">Time</td>
						</tr>
						<tr style="margin-top: 5px">
							<td class="table-content table-left">13th-15th Dec 2024</td>
							<td class="table-content">8:30AM - 5:00PM</td>
						</tr>
						<tr style="height: 13px;">

						</tr>
						<tr style="padding-top: 5px">
							<td class="table-title table-left">Name</td>
							<td class="table-title">Ticket ID</td>
						</tr>
						<tr style="margin-top: 5px">
							<td class="table-content table-left">{{decodeURI(name)}}</td>
							<td class="table-content">#{{ticketId}}</td>
						</tr>
					</table>
				</div>
				<div class="section">
					<div class="border"></div>
					<div class="right"></div>
					<div class="left"></div>
				</div>
				<div class="scan">
					<p>Show the QR Code at the venue to check in</p>
					<div class="qr">
						<qr-code :text="hash_id" :size="200" style="border:10px solid white"></qr-code>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'

	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		data() {
			return {
				name: "",
				ticketId: "",
				hash_id: ""
			}
		},
		created() {
			if (String(this.$route.params.id).length != 12) {
				this.$router.push("/404")
			} else {
				this.getTicket();
			}
		},
		methods: {
			goMap() {
				// window.location.href=;
				window.open("https://goo.gl/maps/5hucWbEqaRKfFtuk9", '_blank').focus();
			},
			getTicket() {
				this.$http.get(this.config.api + "/public/ticket/get/" + this.$route.params.id).then(data => {
					if (data.body.data.length === 1) {
						this.name = data.body.data[0].name;
						this.ticketId = "ATS24" + this.config.orderlify(data.body.data[0].reference_code);
						this.hash_id = data.body.data[0].hash_id;
					} else {
						setTimeout(() => {
							this.$router.push("/404");
						})
					}
				})
			}
		}
	}
</script>
<style scoped>
	body {
		padding: 0;
		margin: 0;
		background-color: rgb(37, 37, 37);
	}

	table {
		border: 0;
		border-spacing: 0;
	}

	.header {
		/* background-color: rgb(56, 129, 185); */
		width: 100%;
		height: 120px;
		/* background-image: ("@/aseets/img/header.png") */
	}

	.box {
		/*height: 460px;*/
		width: 380px;
		background-color: #FFF;
		margin-top: 30px;
		left: 50%;
		position: absolute;
		margin-left: -190px;
		border-radius: 10px;
		padding: 30px;
		padding-top: 18px;
		padding-bottom: 200px;
	}

	.title {
		color: rgb(56, 129, 185);
		font-family: "Nunito", "Hanumann", sans-serif;
		font-weight: bold;
		font-size: 20px;
		padding: 13px 0;
	}

	.location {
		display: inline-flex;
		justify-content: center;
		margin-left: -6px;
	}

	.location span {
		font-family: "Nunito", "Hanumann", sans-serif;
		color: #222;
		font-size: 18px;
		line-height: 25px;
		margin-left: 5px;
		transform: scale(1, 0.9);
		-webkit-transform: scale(1, 0.9);
		/* Safari and Chrome */
		-moz-transform: scale(1, 0.9);
		/* Firefox */
		-ms-transform: scale(1, 0.9);
		/* IE 9+ */
		-o-transform: scale(1, 0.9);
		/* Opera */
	}

	.top {
		margin-top: 20px;

	}

	.bottom {
		margin-top: 10px;
	}

	.table-title {
		font-family: "Arial", sans-serif;
		font-size: 14px;
	}

	.table-content {
		font-family: "Nunito", "Hanumann", sans-serif;
		font-size: 15px;
		font-weight: bold;
		padding: 8px 0px;
	}

	.table-left {
		width: 60%;
	}

	.right,
	.left {
		height: 20px;
		width: 10px;
		background-color: #EEEEEE;
		z-index: 99;
	}

	.right {
		border-bottom-right-radius: 20px;
		border-top-right-radius: 20px;
		float: left;
	}

	.bottom {
		border-bottom-left-radius: 20px;
		border-bottom-right-radius: 20px;
	}

	.left {
		border-bottom-left-radius: 20px;
		border-top-left-radius: 20px;
		float: right;
	}

	.section {
		display: inline-block;
		margin-left: -30px;
		width: calc(100% + 60px);
	}

	.border {
		width: calc(100% - 20px);
		height: 1px;
		position: absolute;
		background-color: #ddd;
		margin-top: 9px;
		margin-left: 10px;
	}

	.scan p {
		font-family: "Nunito", "Hanumann", sans-serif;
		text-align: center;
		font-weight: bold;
		padding: 0;
		margin: 0;
		font-size: 14px;
		margin-top: 5px;
	}

	.qr {
		margin-top: 20px;
		width: 160px;
		height: 160px;
		background-size: cover;
		left: 50%;
		position: absolute;
		margin-left: -80px;
	}

	@media only screen and (max-width: 375px) {
		.box {
			width: 280px;
			margin-left: -170px;
		}
	}

	@media only screen and (max-width: 320px) {
		.box {
			width: 240px;
			margin-left: -150px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/Pass.vue